import {
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  type NumberInputProps,
  NumberInputStepper,
} from "@chakra-ui/react";
import React from "react";

type Props = {
  placeholder?: string;
  fullW?: boolean;
  showBoxShadow?: boolean;
  borderColor?: string;
} & NumberInputProps;

export const NumberInputStyled = React.memo(function NumberInputStyled(props: Props) {
  const { placeholder, fullW, showBoxShadow = true, borderColor, ...rest } = props;

  return (
    <NumberInput display="inline-flex" w={fullW ? "100%" : "initial"} {...rest}>
      <NumberInputField
        borderRadius=".75rem"
        border="1px solid"
        borderColor={borderColor ?? (showBoxShadow ? "whiteAlpha.300" : "gray-base-04")}
        bg="transparent"
        shadow={showBoxShadow ? "0 2px 8px #00000014" : undefined}
        _hover={{
          borderColor: "brand.500",
        }}
        _focus={{
          borderColor: "brand.500",
          backgroundColor: "brand-bg-primary",
          boxShadow: "none",
        }}
        _focusVisible={{
          borderColor: "brand.500",
          boxShadow: "none",
        }}
        placeholder={placeholder}
      />
      <NumberInputStepper>
        <NumberIncrementStepper />
        <NumberDecrementStepper />
      </NumberInputStepper>
    </NumberInput>
  );
});
